export default {
  //api_base: "https://lsbys7xmo5.execute-api.us-east-1.amazonaws.com/dev/",
  api_base: "https://7xr3a2c2kh.execute-api.us-east-1.amazonaws.com/prod/",
  // api_base: "http://localhost:3000/api/",
  local_base: '/data/'
};